import { Navigate } from "react-router-dom";
import { useAppSelector } from "./redux/features/hooks";
import { getLandingPath } from "./lib/navigation";
import "./App.css";

function App() {
  const isAuthenticated = useAppSelector(
    (state) => state.auth.isAuthenticated
  );
  const currentUser = useAppSelector((state) => state.user.currentUser);

  // An anonymous visitor — or an expired/cleared session — has no landing
  // page; send them to login instead of the /no-access dead end.
  if (!isAuthenticated || !currentUser?.roles?.length) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Navigate to={getLandingPath(currentUser)} replace />;
}

export default App;
